/**
 * FAQ Product Section
 * Handles tab filtering for FAQ accordion
 */

class FaqProductSection extends HTMLElement {
  constructor() {
    super();
    this.tabs = null;
    this.items = null;
    this.activeCategory = null;
    this.boundHandleTabClick = this.handleTabClick.bind(this);
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.faq-product__tab');
    this.items = this.querySelectorAll('.faq-product__item');

    if (this.tabs.length === 0 || this.items.length === 0) return;

    const activeTab = this.querySelector('.faq-product__tab--active');
    if (activeTab) {
      this.activeCategory = activeTab.dataset.category;
      this.filterByCategory(this.activeCategory);
    }

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.boundHandleTabClick);
    });
  }

  disconnectedCallback() {
    this.destroy();
  }

  destroy() {
    if (this.tabs) {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.boundHandleTabClick);
      });
    }
    this.tabs = null;
    this.items = null;
    this.activeCategory = null;
  }

  handleTabClick(event) {
    const tab = event.currentTarget;
    const category = tab.dataset.category;

    if (category === this.activeCategory) return;

    this.tabs.forEach((t) => {
      t.classList.remove('faq-product__tab--active');
      t.setAttribute('aria-selected', 'false');
    });

    tab.classList.add('faq-product__tab--active');
    tab.setAttribute('aria-selected', 'true');
    this.activeCategory = category;

    this.filterByCategory(category);
  }

  filterByCategory(category) {
    this.items.forEach((item) => {
      if (item.dataset.category === category) {
        item.hidden = false;
      } else {
        item.hidden = true;
        item.classList.remove('is-active');
      }
    });
  }
}

customElements.define('faq-product-section', FaqProductSection);

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('faq-product-section');
  if (section && section.connectedCallback) {
    section.connectedCallback();
  }
});
